import PaymentDebitMachine from '@/models/payment.model.js'
import PaymentCreditMachine from '@/models/payment-credit-machine.model.js'
import PaymentMoney from '@/models/payment-money.model.js'

import {createPaymentLogDB, downloadDocumentBDRbx} from '@/repositories/payment.repository';

import {getDateToPT} from '@/services/date.service'

import userStore from "@/store/user.store"
import adminStore from "@/store/admin.store"

const _payment_types = { 
  money: {
    description: "Dinheiro"
  },
  credit_card_machine: {
    description: "cartão de crédito"
  },
  debit_card_machine: {
    description: "Cartão de débito"
  }
}

const payment = {}

let data = null;

payment.set = (type, input) => {
  if (!_payment_types[type]) return null

  if (type === 'money') {
    const paymentMoney = new PaymentMoney({ ...input })
    data = paymentMoney.getData()
  } else if (type === 'credit_card_machine') {
    const paymentCreditMachine = new PaymentCreditMachine({ ...input })
    data = paymentCreditMachine.getData()
  } else if (type === 'debit_card_machine') {
    const paymentDebit = new PaymentDebitMachine({ ...input })
    data = paymentDebit.getData()
  }

  console.log(data)
}

// @todo criar log
payment.log = async (receipt, documentPaymentForShipping) => {
  const {codigo} = userStore.getters.user;
  const admin = adminStore.getters.admin;

  const {documentNumber, idTransaction, typeCard, authenticationCard, modeCard, modePay, flagCard, value} = receipt;

  const data = {
    delivered: false,
    useDate: new Date().toISOString(),
    userCode: codigo,
    documentNumber,
    idTransaction,
    typeCard,
    authenticationCard,
    value,
    terminal: admin.selectedTotem.name,
    modeCard,
    modePay,
    flagCard,
    billPay: JSON.parse(receipt.billPay).toString()
  }

  const documentPayment = {...data, useDate: getDateToPT(data.useDate) }

  const result = await createPaymentLogDB(data);

  const docId = result.id;

  if (docId) {
    const {documentNumber, idTransaction} = data;

    downloadDocumentBDRbx(documentPaymentForShipping, docId, documentPayment, documentNumber, idTransaction)
  }
}

export default payment
